import { useMemo } from 'react';

import { useAtomValue } from 'jotai';

import { useLayouts, useLayoutCustomizations } from '@queries';
import { activityAtom } from '@store';

export const useActiveLayout = () => {
    const { data: layouts } = useLayouts();
    const activity = useAtomValue(activityAtom);
    const activeLayoutId = activity?.layoutId;

    const activeLayout = useMemo(
        () => (layouts ? layouts?.find(({ id }) => id === activeLayoutId) || layouts[0] : null),
        [layouts, activeLayoutId],
    );

    const { data: customizations } = useLayoutCustomizations(activeLayout?.id);

    const data = useMemo(() => {
        if (!activeLayout || !customizations) {
            return null;
        }
        return { ...activeLayout, customizations };
    }, [activeLayout, customizations]);

    return data;
};
